import Select from 'react-select';
import BaseInputBlock, { BaseInputBlockProps } from './base-input-block';
import { useFillableBlockResponse } from './common';
import { SelectionBlock as ISelectionBlock, SelectOptionType, SelectionType } from '@/lib/types';

export default function SelectionBlock({ block }: BaseInputBlockProps<ISelectionBlock>) {
  const { payload, updatePayload } = useFillableBlockResponse({ block });

  function getSelectedItems(selects?: Array<string>) {
    if (typeof selects === 'string') {
      return block.properties.options.find((opt) => selects === opt.value);
    }
    return selects && selects?.length
      ? block.properties.options.filter((opt) => selects.find((sel) => sel === opt.value))
      : [];
  }

  function setItems(opts?: SelectOptionType[]) {
    updatePayload({
      value:
        opts?.map((item) => {
          return item.value;
        }) ?? [],
    });
  }

  function setValue(opt?: SelectOptionType) {
    updatePayload({
      value: opt ? [opt?.value] : null,
    });
  }

  return (
    <BaseInputBlock block={block}>
      <Select
        value={getSelectedItems(payload?.value)}
        onChange={(e) =>
          block.properties.selectionType === SelectionType.Multi
            ? setItems(e as SelectOptionType[])
            : setValue(e as SelectOptionType)
        }
        isMulti={block.properties.selectionType === SelectionType.Multi}
        options={block.properties.options}
        menuPosition={'fixed'}
        isClearable={true}
        closeMenuOnSelect={block.properties.selectionType === SelectionType.Single}
        styles={{
          container: (provided) => ({
            ...provided,
            width: '100%',
          }),
          menuPortal: (provided) => ({
            ...provided,
            zIndex: 100,
          }),
          multiValue: (base) => ({
            ...base,
            fontSize: '0.875rem',
          }),
          singleValue: (base) => ({
            ...base,
            fontSize: '0.875rem',
          }),
          option: (base) => ({
            ...base,
            fontSize: '0.875rem',
          }),
          placeholder: (base) => ({
            ...base,
            fontSize: '0.875rem',
          }),
        }}
      />
    </BaseInputBlock>
  );
}
